import React, { useState } from "react";
import { techStacks } from "../mock/mock";

const TechStack = () => {
  const categories = Object.keys(techStacks);
  const [active, setActive] = useState(categories[0]);
  return (
    <section id="technologies" className="section-pad bg-[#0A0A0A] text-[#F4F1EA] grid-dots-invert border-b-2 border-[#0A0A0A]">
      <div className="container-x">
        <div className="max-w-3xl mb-12">
          <p className="eyebrow text-[#F4F1EA]/50">/ Tech Stack</p>
          <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
            The Technology <span className="hl-invert">Behind Us</span>
          </h2>
          <p className="mt-5 text-[#F4F1EA]/70">
            From AI to cloud computing, we pioneer emerging technologies to craft fast, reliable,
            next-generation software solutions.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 mb-10">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`mono text-[12px] font-bold uppercase tracking-widest px-5 py-3 border-2 border-[#F4F1EA] transition-colors ${
                active === c ? "bg-[#F4F1EA] text-[#0A0A0A]" : "text-[#F4F1EA] hover:bg-[#F4F1EA]/10"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="flex flex-wrap gap-4">
          {techStacks[active].map((tech) => (
            <div key={tech} className="display font-bold uppercase px-6 py-4 border-2 border-[#F4F1EA]/40 hover:border-[#F4F1EA] hover:-translate-y-1 transition-all">
              {tech}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
